export default __webpack_public_path__ + "static/media/game_4_m.8547fcc2.png";